import type { TFunction } from "i18next";
import type { ChangeEventHandler, ComponentProps, FocusEventHandler } from "react";
import { withTranslation } from "react-i18next";
import { SkeletonLoader } from "@hubertai/hubert-component-library";
import { Text } from "../elements";

interface TextboxProps extends ComponentProps<"input"> {
    label?: string;
    helpText?: string;
    handleChange: ChangeEventHandler<HTMLInputElement>;
    handleBlur: FocusEventHandler<HTMLInputElement>;
    error?: string;
    touched?: boolean;
    t: TFunction;
    loading?: boolean;
}

const Textbox = ({
    type = "text",
    label = "",
    name,
    id = "",
    placeholder = "",
    helpText = "",
    disabled = false,
    handleChange,
    handleBlur,
    value,
    error = "",
    touched = false,
    t,
    loading = false,
}: TextboxProps) =>
    loading ? (
        <SkeletonLoader height="46px" />
    ) : (
        <div className="form-group">
            <label htmlFor={name} className={`form-label ${!label ? "h-5" : ""}`}>
                {label}
            </label>
            <input
                id={id}
                className={`form-input ${error && touched ? "error" : ""} ${disabled ? "disabled" : ""}`.trim()}
                type={type}
                name={name}
                placeholder={placeholder}
                onChange={handleChange}
                onBlur={handleBlur}
                value={value}
                autoComplete="off"
                disabled={disabled}
                dir={name === "email" || name === "phoneNumber" ? "ltr" : undefined}
            />
            {helpText && (
                <Text size="small" block className="help-text">
                    {helpText}
                </Text>
            )}
            {error && touched && (
                <Text size="small" block className="form-error">
                    {t(error)}
                </Text>
            )}
        </div>
    );

export default withTranslation()(Textbox);
